// e561c71c84520e04e36e4ce9b1e8000a0527df6f|className=FileApi|type=angular|apiName=agent|apiEnumKey=Agent|operationHash=f9097f2e976dcf245376c4b1a91e3a94660a716c|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseChatFileAttachmentFromJSON } from '../../../parsers/ChatFileAttachment';
import { parseFileApiGetUploadUrlParamsToJSON } from '../../../parsers/FileApiGetUploadUrlParams';
import { parseUploadUrlResponseFromJSON } from '../../../parsers/UploadUrlResponse';
import { parseUploadValidateBodyToJSON } from '../../../parsers/UploadValidateBody';

export class FileApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags FileApi
   * @name FileApiGetUploadUrl
   * @summary Get a presigned S3 upload URL for a file
   * @request GET:/customers/{customerId}/files/upload-url
   * @secure
   */
  getUploadUrl(
    {
      customerId,
      ...query
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/files/upload-url`,
        route: '/customers/{customerId}/files/upload-url',
        method: 'GET',
        query: parseFileApiGetUploadUrlParamsToJSON(query),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseUploadUrlResponseFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags FileApi
   * @name FileApiValidateUpload
   * @summary Validate a completed file upload and return its metadata
   * @request POST:/customers/{customerId}/files/upload-validate
   * @secure
   */
  validateUpload(
    {
      customerId,
    },
    data,
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/files/upload-validate`,
        route: '/customers/{customerId}/files/upload-validate',
        method: 'POST',
        body: parseUploadValidateBodyToJSON(data),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseChatFileAttachmentFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags FileApi
   * @name FileApiDownloadFile
   * @summary Download file
   * @request GET:/customers/{customerId}/files/{fileId}
   * @secure
   */
  downloadFile(
    {
      customerId,
      fileId,
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/files/${fileId}`,
        route: '/customers/{customerId}/files/{fileId}',
        method: 'GET',
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    isContentArray: false,
  }),
      },
    );
  }

  static ɵfac = function FileApi_Factory(t) { return new (t || FileApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: FileApi, factory: FileApi.ɵfac, providedIn: 'root' });
}
